export const CLEAR_ORDER_BOOK = 'CLEAR_ORDER_BOOK';
export const INIT_ORDER_BOOK = 'INIT_ORDER_BOOK';
export const UPDATE_ORDER_BOOK = 'UPDATE_ORDER_BOOK';
export const UPDATE_PREV_ASK_PRICE = 'UPDATE_PREV_ASK_PRICE';
